import mainFields from '../../db/main-fields'
import {merge} from "lodash-es";

export default {
  state: {
    fields: mainFields.basic
  },
  getters: {
    getBasic: state => state
  },
  mutations: {
    SET_BASIC_FIELD (state, { index, data }) {
      state.fields[index] = Object.assign(state.fields[index], data)
    },
    SET_OPTIONS (state, data) {
      state = merge(state, data)
    },
  },
  actions: {
    async updateField ({ commit, dispatch, rootState }, { index, data }) {
      commit('SET_BASIC_FIELD', { index, data })
    },
    async updateOptions ({ commit, dispatch, rootState }, data) {
      commit('SET_OPTIONS', data)
    }
  }
}
